import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Users.css"; // ✅ Reuse same CSS for consistent style

const Society = () => {
  const [societies, setSocieties] = useState([]);
  const [filteredSocieties, setFilteredSocieties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [societyName, setSocietyName] = useState("");
  const [creating, setCreating] = useState(false);

  // 🟢 Fetch societies on mount
  useEffect(() => {
    fetchSocieties();
  }, []);

  const fetchSocieties = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await axios.get("/api/admin/stats/societies", {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
      });
      const data = Array.isArray(res.data) ? res.data : [res.data];
      setSocieties(data);
      setFilteredSocieties(data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch societies.");
    } finally {
      setLoading(false);
    }
  };

  // 🔍 Search Filter
  useEffect(() => {
    const lowerQuery = searchQuery.toLowerCase();
    const filtered = societies.filter(
      (s) =>
        s.societyName?.toLowerCase().includes(lowerQuery) ||
        s.societyCode?.toLowerCase().includes(lowerQuery)
    );
    setFilteredSocieties(filtered);
  }, [searchQuery, societies]);

  // 🏗️ Create Society API Call
  const handleCreateSociety = async (e) => {
    e.preventDefault();
    if (!societyName.trim()) {
      alert("Please enter a society name");
      return;
    }

    try {
      setCreating(true);
      const token = localStorage.getItem("token");
      await axios.post(
        "/api/admin/create-society",
        { societyName },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        }
      );
      setSocietyName("");
      await fetchSocieties(); // 🔁 Refresh list
      alert("✅ Society created successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to create society");
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="users-page">
      <h2>🏘️ Society Management</h2>
      <p>View, search, and create new societies.</p>

      {/* 🏗️ Create Society Form */}
      <form className="create-form" onSubmit={handleCreateSociety}>
        <input
          type="text"
          placeholder="Enter society name..."
          value={societyName}
          onChange={(e) => setSocietyName(e.target.value)}
          required
        />
        <button type="submit" disabled={creating}>
          {creating ? "Creating..." : "Create Society"}
        </button>
      </form>

      {/* 🔍 Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by society name or code..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {loading ? (
        <p className="loading">Loading societies...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <div className="table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Society Name</th>
                <th>Society Code</th>
              </tr>
            </thead>
            <tbody>
              {filteredSocieties.length > 0 ? (
                filteredSocieties.map((s) => (
                  <tr key={s.id}>
                    <td>{s.id}</td>
                    <td>{s.societyName}</td>
                    <td>{s.societyCode}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center", color: "#bbb" }}>
                    No societies found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Society;
